module.exports = __webpack_public_path__ + "img/gold1.0079e80c.png";